import type { UseMutationOptions } from '@tanstack/react-query';

import type { ApiError, SignupResponse } from '../useSignupMutation/types';

export interface CodeLoginRequest {
  email: string;
  customerId: string;
  phoneVerificationToken: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
}

export interface CodeLoginResponse extends SignupResponse {
  // Uses the same response structure as signup
}

export type UseCodeLoginMutationOptions = Omit<
  UseMutationOptions<CodeLoginResponse, ApiError, CodeLoginRequest>,
  'mutationFn'
> & {
  /**
   * Whether a rejection reports `sign_in_failed`. The standby flow turns it off
   * because its new-user branch is signalled by a rejection that is not a
   * failure.
   */
  trackFailure?: boolean;
  /**
   * Whether a rejection is reported to the loggers. The standby flow turns it
   * off because its new-user branch is signalled by a rejection that is not a
   * failure, and the server names the missing profile fields in the body.
   */
  logFailure?: boolean;
};

/** Code carried by a rejection that never reached the server. */
export const NETWORK_ERROR_CODE = 'NETWORK_ERROR';

// Re-export ApiError for convenience
export type { ApiError } from '../useSignupMutation/types';
